import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_LAMBDA_URL
});

export default api;